import { TOCSidebarProps } from '@/modules/core/components/TOCSidebar/TOCSidebar.types';
import { HEALTH_PLAN_MODULES } from '@/modules/HealthPlan/HealthPlan.constants';

export const planConfigModuleNames = {
  [HEALTH_PLAN_MODULES.BASIC_PROPERTIES]: 'Basic Properties',
  [HEALTH_PLAN_MODULES.COVERAGE_LEVELS]: 'Coverage Levels',
  [HEALTH_PLAN_MODULES.FINAL_SETUP]: 'Final Setup',
} as const;

export const useHealthPlanConfigModules = (): TOCSidebarProps['stepsMap'] => Object
  .keys(planConfigModuleNames)
  .reduce((map, anchorId) => ({
    ...map,
    [anchorId]: {
      title: planConfigModuleNames[anchorId],
    },
  }), {});
